import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {CaseFormsService} from '../../../case-forms/case-forms.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../../globals';
import {DataPatientCaseWorkItemToothModel} from '../../../../models/teeth/data-patient-case-work-item-tooth.model';
import {DataPatientCaseWorkItemToothSurfaceModel} from '../../../../models/teeth/data-patient-case-work-item-tooth-surface.model';
import {ToothSurfaceConfigurationModel} from '../../../../models/teeth/tooth-surface-configuration.model';
import {ToothService} from '../../../../services/tooth.service';
import {StaticDataService} from '../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
  selector: 'app-tooth-surface-picker',
  templateUrl: './tooth-surface-picker.component.html',
  styleUrls: ['./tooth-surface-picker.component.css']
})
export class ToothSurfacePickerComponent implements OnInit {

  caseWorkItemID: string;
  dataPatientCaseWorkItemToothSurfaces: DataPatientCaseWorkItemToothSurfaceModel[] = [];
  cfgToothSurfaces: ToothSurfaceConfigurationModel[] = [];
  vvToothSurfaces: EnumValidValueItemModel[] = [];
  isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<ToothSurfacePickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private caseService: CaseFormsService,
    private snackBar: MatSnackBar,
    public globals: Globals,
    private toothService: ToothService,
    private staticDataService: StaticDataService,
  ) {  }

  ngOnInit() {

    this.caseWorkItemID = this.data.caseWorkItemId;
    this.init();
  }

  async init() {
    const promises: any[] = [
      this.arService.getCaseWorkItemTeethSurfaces(this.caseWorkItemID).toPromise(),
      this.toothService.getAllToothSurfaces().toPromise(),
      this.arService.getEnumValidValueItemsByValidValueName('enumToothSurface').toPromise(),
    ];

    this.isLoading = true;

    try {
      const results: any[] = await Promise.all(promises);
      this.dataPatientCaseWorkItemToothSurfaces = results[0];
      this.cfgToothSurfaces = results[1];
      this.vvToothSurfaces = results[2];
      this.isLoading = false;
    } catch (e) {
      this.createMessage('Problem loading teeth surfaces', 'Error');
    }
  }

  returnToothList(teeth: DataPatientCaseWorkItemToothModel[]) {
    let list = '';
    if (teeth) {
      if (teeth.length) {
        teeth.forEach(a => {
          list = list + a.Notation + ', ';
        });

        // remove last comma
        list = list.slice(0, -2);
      }
    }

    return list;
  }

  saveSelection() {
    this.dataPatientCaseWorkItemToothSurfaces.forEach(a => {

      // build string array of tooth surface selections
      const toothSurfaces: string[] = [];
      a.cfgToothSurfaces.forEach(b => {
        toothSurfaces.push(b.ToothSurfaceId);
      });

      this.arService.saveCaseWorkItemTeethSurfaces(a.CaseWorkItemToothID, toothSurfaces)
        .subscribe(response => {
          this.createMessage('Surfaces Saved', 'Success');
          this.isLoading = false;
          this.cancel(true);
        }, err => {
          this.createMessage('Something went wrong', 'Error');
          this.isLoading = false;
        });
    });
  }

  cancel(payload) {
    this.dialogRef.close(payload);
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  showSurfaceForTooth(ToothId: string, enumToothSurfaceId: string) {
    const surface = this.cfgToothSurfaces.filter(a => a.ToothId === ToothId && a.enumToothSurfaceID === enumToothSurfaceId);
    if (surface.length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  toothSurfaceSelected(ToothId: string, enumToothSurfaceId: string) {
    const surface = this.dataPatientCaseWorkItemToothSurfaces.find(a => a.ToothID === ToothId);
    if (surface) {
      if (surface.cfgToothSurfaces) {
        const selected = surface.cfgToothSurfaces.filter(a => a.enumToothSurfaceID === enumToothSurfaceId);
        if (selected.length > 0) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  toothSurfaceCheckChange(CaseWorkItemToothID: string, ToothID: string, ValidValueItemId: string, event: MatCheckboxChange) {
    this.dataPatientCaseWorkItemToothSurfaces.forEach(a => {
      if (a.CaseWorkItemToothID === CaseWorkItemToothID) {

        // if list is null
        if (!a.cfgToothSurfaces) {
          a.cfgToothSurfaces = [];
        }

        if (event.checked) {
          // add item
          const surface = a.cfgToothSurfaces.find(b => b.ToothId === ToothID && b.enumToothSurfaceID === ValidValueItemId);
          if (!surface) {
            const toothSurface = new ToothSurfaceConfigurationModel();
            toothSurface.ToothId = ToothID;
            toothSurface.enumToothSurfaceID = ValidValueItemId;
            toothSurface.ToothSurfaceId = this.returnToothSurfaceId(ToothID, ValidValueItemId);
            a.cfgToothSurfaces.push(toothSurface);
          }
        } else{
          // remove item
          const surface = a.cfgToothSurfaces.find(b => b.ToothId === ToothID && b.enumToothSurfaceID === ValidValueItemId);
          if (surface) {
            a.cfgToothSurfaces = a.cfgToothSurfaces.filter(c => c !== surface);
          }
        }
      }
    });
  }

  private returnToothSurfaceId(ToothID: string, ValidValueItemId: string) {
    const surface = this.cfgToothSurfaces.find(a => a.ToothId === ToothID && a.enumToothSurfaceID === ValidValueItemId);
    if (surface) {
      return surface.ToothSurfaceId;
    }
    return '';
  }
}
